import {
  GET_PERMIT_LIMITS_REQUEST,
  GET_PERMIT_LIMITS_SUCCESS,
  GET_PERMIT_LIMITS_ERROR,
} from '../actions/types';

const defaultState = {
  matchingLimits: [],
  isLoading: false,
  error: '',
};

/**
   * Permit type(s) reducer logic. All of the permit types loaded in on dashboard.
   * @param {Object} state - The state for this reducer in Redux.
   * @param {Object} action - The action which details what to do & what state to update.
   * @returns {Object} - Newly created state object.
   */
export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_PERMIT_LIMITS_REQUEST:
      return { ...state, isLoading: true };
    case GET_PERMIT_LIMITS_SUCCESS:
      return { ...state, matchingLimits: action.payload, isLoading: false };
    case GET_PERMIT_LIMITS_ERROR:
      return { ...state, error: action.payload, isLoading: false };
    default:
      return state;
  }
};
